import { ActionTypes }  from './actions/types';
import { reducerState } from './types';

const prod = process.env.NODE_ENV === 'production';

const initialState: reducerState = {
   actionInit:           false,
   actionComplete:       false,
   showError:            false,
   showOrgNameTextField: true,
   showLoader:           prod
}; 

const reducer = (state = initialState, action: ActionTypes) => {

  switch (action.type) {
    


    case 'SUBMITION_INIT':
    {
       return {
         ...state,
         actionInit: true
       }
    }

    case 'SUBMITION_COMPLETED':
    {
       return {
         ...state,
         actionInit:     false,
         actionComplete: true
       }
    }

    case 'STOP_SHOWING_LOADER': {
      return {
         ...state,
         showLoader: false,
      }
    }

    case 'SHOW_ERROR':
    {
       return {
          ...state,
          showError:  true,
          actionInit: false,
          showLoader: false,
       }
    }

    case 'SET_SHOW_ORG_NAME_TEXT_FIELD': 
    {
      return {
         ...state,
         showOrgNameTextField: action.payload
      }
   }


    case 'RESET':
    {
       return {
         ...initialState,
         showLoader:           false,
         showOrgNameTextField: state.showOrgNameTextField
      }
    }


    default: return state;
  }
};

export type reducerType = ReturnType<typeof reducer>;

export { reducer };
